/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { b as __awaiter, c as __generator } from './tslib.es6-e01eabb2.js';

/**
 * 从 CDN 加载 script
 * @param {string} url 资源路径
 * @param {number} retryTimes 重连次数
 * @param {number} maxRetryTimes 最大重连次数
 * @param {function} resolveCB 成功回调
 * @param {function} rejectCB 失败回调
 */
function getScriptFromCDN(url, retryTimes, maxRetryTimes, resolveCB, rejectCB) {
    var doc = document;
    var head = doc.head || doc.getElementsByTagName('head')[0] || doc.documentElement;
    var node = doc.createElement('script');
    node.setAttribute('charset', 'utf-8');
    if ('onload' in node) {
        node.onload = function () {
            resolveCB === null || resolveCB === void 0 ? void 0 : resolveCB();
        };
        node.onerror = function () {
            if (retryTimes < maxRetryTimes) {
                // 失败重连
                // eslint-disable-next-line no-plusplus, no-param-reassign
                retryTimes++;
                getScriptFromCDN(url, retryTimes, maxRetryTimes, resolveCB, rejectCB);
            }
            else {
                // 超过最大重连次数
                rejectCB === null || rejectCB === void 0 ? void 0 : rejectCB();
            }
        };
    }
    else {
        // IE 浏览器
        // @ts-ignore
        node.onreadystatechange = function () {
            // @ts-ignore
            if (/loaded|complete/.test(node.readyState)) {
                resolveCB === null || resolveCB === void 0 ? void 0 : resolveCB();
            }
        };
    }
    node.async = true;
    node.src = url;
    head.appendChild(node);
}
/** 重试次数 */
var MAX_CDN_RESOURCE_RETRY_TIMES = 1;
/**
 * 加载 scripts
 * @param {Array} libs 资源列表
 * @param {number} maxRetryTimes 最大重连次数
 * @returns {Promise}
 */
function loadScripts(libs, maxRetryTimes) {
    if (maxRetryTimes === void 0) { maxRetryTimes = MAX_CDN_RESOURCE_RETRY_TIMES; }
    var promiseList = [];
    var _loop_1 = function (i) {
        var promise = new Promise(function (resolve, reject) {
            getScriptFromCDN(libs[i], 0, maxRetryTimes, resolve, reject);
        });
        promiseList.push(promise);
    };
    // eslint-disable-next-line no-plusplus
    for (var i = 0; i < libs.length; i++) {
        _loop_1(i);
    }
    return Promise.all(promiseList);
}
/**
 * 依次加载 scripts
 * @param {Array} libs 资源列表
 * @param {number} maxRetryTimes 最大重连次数
 * @returns {Promise}
 */
function loadScriptsByOrder(libs, maxRetryTimes) {
    if (maxRetryTimes === void 0) { maxRetryTimes = MAX_CDN_RESOURCE_RETRY_TIMES; }
    return __awaiter(this, void 0, void 0, function () {
        var promiseList, _loop_2, i;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    promiseList = [];
                    _loop_2 = function (i) {
                        var p;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0: return [4 /*yield*/, new Promise(function (resolve, reject) {
                                        getScriptFromCDN(libs[i], 0, maxRetryTimes, resolve, reject);
                                    })];
                                case 1:
                                    p = _b.sent();
                                    promiseList.push(p);
                                    return [2 /*return*/];
                            }
                        });
                    };
                    i = 0;
                    _a.label = 1;
                case 1:
                    if (!(i < libs.length)) return [3 /*break*/, 4];
                    return [5 /*yield**/, _loop_2(i)];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3:
                    i++;
                    return [3 /*break*/, 1];
                case 4: return [2 /*return*/, Promise.resolve(promiseList)];
            }
        });
    });
}

export { loadScriptsByOrder as a, loadScripts as l };
